import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, ScreenView } from "../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import { notifycatch } from "../utils/toast";
import { Table, Tooltip, Select, Col, Row, Pagination, Input, Modal, Checkbox, Button } from 'antd';
import mediaKitIcon from '../assets/images/icons/export_download_icon.svg';
import columnIcon from '../assets/images/icons/column.svg'
import HoverCloseIcon from '../assets/images/icons/hover_close.svg';
import tagRomoveIcon from '../assets/images/icons/tag_close_icon.svg';
import filterIcon from '../assets/images/icons/filter.svg';
import { SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom'
import FullLoader from "../assets/images/full-page-loader.gif"
import prevIcon from '../assets/images/icons/chevron-left.svg';
import nextIcon from '../assets/images/icons/chevron-right.svg';
import wifiIcon from '../assets/images/icons/wifi.svg';
import importDarkIcon from '../assets/images/icons/import-dark.svg';
import { jwtDecode } from "jwt-decode";
import ZoneCreate from "./ZoneCreate";
import { saveAs } from "file-saver";
import ZoneImport from "./ZoneImport";
import addIcon from '../assets/images/icons/add.svg';
import copyIcon from '../assets/images/icons/copy.svg';
import zoneInfoIcon from '../assets/images/icons/zone-info.svg';
import partialDataIcon from '../assets/images/icons/parital_data_icon.svg';
import timeDataIcon from '../assets/images/icons/time_data_icon.svg';
import noData from '../assets/images/data-graph/no-data.svg';
import TableLoader from "./TableLoader";
import errorData from '../assets/images/data-graph/error-data.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import ZoneViewEdit from "./ZoneViewEdit";
const { Option } = Select;
const ZoneListing = () => {


    const publisherfromPublisherList = new URLSearchParams(useLocation().search).get("publisher");

    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)
    const [pageView, setPageView] = useState("table")
    const [checkRole, setCheckRole] = useState("admin")
    const [zoneViewId, setZoneViewId] = useState("")
    const [zoneViewName, setZoneViewName] = useState("")
    const [zoneCategory, setZoneCategory] = useState("")
    const [columnPartialData, setColumnPartialData] = useState(false)
    const [columnTimeData, setColumnTimeData] = useState("")


    const [colvis, setColvis] = useState({
        "z_cate": true,
        "invent_type": true,
        "p_adkId": true,
        "p_name": true,
        "impressions": true,
        "givtImpressions": true,
        "sivtImpressions": true,
        "givtSivtImp": true,
        "viewability": true,
        "discrep": true,
        "pix_updatedAt": true,
        "createdAt": true
    })

    function addCommasToNumber(num) {
        const isDecimal = num % 1 !== 0;
        let numStr = num.toString();
        let [wholePart, decimalPart] = numStr.split(".");
        wholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (isDecimal) {
            numStr = `${wholePart}.${decimalPart}`;
        } else {
            numStr = wholePart;
        }

        return numStr;
    }

    const exportHeader =
        [
            {
                label: "Status",
                key: "status",
            },
            {
                label: "Zone Id",
                key: "z_Id",
            },
            {
                label: "Zone Name",
                key: "z_name",
            },
            {
                label: "Category",
                key: "z_cate",
            },
            {
                label: "Inventory Type",
                key: "invent_type",
            },
            {
                label: "Publisher Id",
                key: "p_adkId",
            },
            {
                label: "Publisher Name",
                key: "p_name",
            },
            {
                label: "Created At",
                key: "createdAt",

            },
            {
                label: " Gross Ad Count",
                key: "impressions",
            },
            {
                label: "GIVT Ad Count",
                key: "givtImpressions",
            },
            {
                label: "SIVT Ad Count",
                key: "sivtImpressions",
            },
            {
                label: "IVT",
                key: "givtSivtImp",
            },
            {
                label: "Net Viewability",
                key: "viewability",
            },
            {
                label: "Discrepancies",
                key: "discrep",
            },
            {
                label: "Updated At (UTC)",
                key: "pix_updatedAt",
            },


        ]

    const [exportLoading, setExportLoading] = useState(false)
    const columnsAll = [
        {
            title: 'Action',
            dataIndex: 'action',
            // render: (data) => <div className='badge_content--approved'>{data}</div>,
            fixed: 'left',
            width: 60,

            render: (text, record) => {
                return (
                    <div className='btn_group'

                    >
                        {/* <button className='btn_icon btn'><img src={editIcon} alt='USP' /></button> */}
                        <Tooltip title="Zone Info">
                            <button className='download_icon download_icon_d2'
                                onClick={() => {

                                    if (record.z_cate === "Prebid") {
                                        setDataModal_prebid({
                                            "hostInfo": record.hostInfo ? record.hostInfo : [],
                                            "userSyncTag": record.userSyncTag ? record.userSyncTag : []
                                        })

                                    }
                                    else if (record.z_cate === "Open RTB") {
                                        setDataModal_openrtb({
                                            "urlTemplate": record.templateUrl ? record.templateUrl : [],
                                            "userSyncTag": record.userSyncTag ? record.userSyncTag : []
                                        })

                                    }
                                    else if (record.z_cate === "Vast Zone") {
                                        setDataModal_vastzone({
                                            "userSyncTag": record.vastTagInfo ? record.vastTagInfo : []
                                        })
                                    }
                                    else if (record.z_cate === "vast_aniview") {
                                        setDataModal_vast_aniview({
                                            "userSyncTag": record.aniviewTag ? record.aniviewTag : []
                                        })
                                    }
                                    else if (record.z_cate === "Player Tag" || record.z_cate === "tag_outstream") {
                                        setDataModal_playertag({
                                            "userSyncTag": record.aniviewTag ? record.aniviewTag : []
                                        })
                                    }
                                    else if (record.z_cate === "GAM Tag") {
                                        setDataModal_gamtag({
                                            "userSyncTag": record.gamInfoTag ? record.gamInfoTag : []
                                        })
                                    }

                                    setFormTypeList(record.z_cate)
                                    setActiveKey("1")
                                    setIsModalVisible(true)

                                }}
                            >
                                <img src={wifiIcon} alt='USP' /></button>
                        </Tooltip>
                    </div>
                )
            },

        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            fixed: 'left',
            width: 110,
            render: (text, record) => <div className='w_100 position-relative'>
                <Select
                    className={`form_select badge_content--${text ? "approved" : "declined"}`}
                    dropdownStyle={{
                        width: '12rem'
                    }}
                    value={text ? "Enabled" : "Disabled"}

                    options={
                        [{ label: "Enabled", value: "Enabled" }, { label: "Disabled", value: "Disabled" }]
                    }
                    onChange={(event) => {

                        let status = Cookies.get("token_xapads_ssp") ? true : false;
                        if (status) {
                            let token = Cookies.get("token_xapads_ssp");

                            let payload = {
                                "status": event,
                                "z_cate": record?.z_cate
                            }

                            setLoading(true)
                            axios
                                .put(configData.SERVER_URL + `zone/statusUpdate?zoneId=` + record.z_Id, payload, {
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": token,
                                    },
                                })
                                .then((response) => {
                                    setApicall(!apiCall)
                                    notifysuccess(response.data.message);

                                })
                                .catch((error) => {
                                    if (error?.response) {
                                        if (error.response.data.message?.length !== 0) {
                                            notifyfailure(error.response.data.message)
                                        }
                                    } else {
                                        notifycatch()
                                    }
                                    setLoading(false)

                                });

                        }
                    }
                    }
                />
            </div>,
        },
        {
            title: "Zone Id",
            dataIndex: "z_Id",
            width: 120,
            key: "z_Id",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            fixed: 'left',
            render: (data) => {
                return (
                    <div className='align_y_d2'>
                        <>

                            {data}
                        </>
                    </div>
                )
            }
        },
        {
            title: "Zone Name",
            dataIndex: "z_name",
            width: 150,
            key: "z_name",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => {
                return (
                    <div className='anchor_text_link_d2'
                        onClick={() => {
                            setPageView("view");
                            setZoneViewId(record.z_Id)
                            setZoneViewName(record.z_name)
                            setZoneCategory(record.z_cate)
                        }}
                    >
                        <>
                            {data}

                        </>


                    </div>
                )
            }
        },
        {
            title: "Category",
            dataIndex: "z_cate",
            width: 150,
            key: "z_cate",
            hidden: !colvis["z_cate"],
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => {
                return (
                    <>

                        <div className={`table_badges--d2 --${text === "Prebid" ? "blue" : text === "Open RTB" ? "green" : text === "Vast Zone" ? "purple" : (text === "Player Tag" || text === "tag_outstream") ? "yellow" : text === "vast_aniview" ? "violet" : "orange"}`}>
                            {text === "vast_aniview" ? <>Vast (Aniview)</> : text === "Vast Zone" ? <>Vast (ADK)</> : text === "tag_outstream" ? <>Player Tag (Outstream)</> : text === "Player Tag" ? <>Player Tag (Instream)</> : <>{text}</>}
                        </div>
                    </>
                )
            }
        },
        {
            title: "Inventory Type",
            dataIndex: "invent_type",
            width: 145,
            key: "invent_type",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            hidden: !colvis["invent_type"],
            render: (data) => <div className='text_dark'>{data}</div>,
        },
        // {
        //     title: "Publisher Id",
        //     dataIndex: "p_adkId",
        //     width: 200,
        //     key: "p_adkId",
        //     sortDirections: ['ascend', 'descend', 'ascend'],
        //     sorter: true,
        //     hidden: !colvis["p_adkId"],
        //     render: (data) => <div className='text_dark'>{data}</div>,
        // },
        {
            title: "Publisher Id",
            dataIndex: "p_adkId",
            width: 135,
            key: "p_adkId",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            hidden: !colvis["p_adkId"],
            render: (data, record) => <div className='text_dark'>{data}</div>,
        },
        {
            title: "Publisher Name",
            dataIndex: "p_name",
            width: 150,
            key: "p_name",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            hidden: !colvis["p_name"],
            render: (data, record) => {
                return (
                    <div className='text_dark'>
                        <>

                            {data}
                        </>
                    </div>
                )
            }
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            width: 120,
            key: "createdAt",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data) => <div className='text_dark'>{data}</div>,
            hidden: !colvis["createdAt"]
        },
        {
            title:
                <>

                    <span >
                        Gross Ad Count
                        {columnPartialData ?
                            <Tooltip
                                title={`Partial Data (${columnTimeData})`}
                            >
                                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                            </Tooltip>
                            :

                            <Tooltip
                                title={`Complete Data (${columnTimeData})`}
                            >
                                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                            </Tooltip>
                        }
                    </span>


                </>,
            dataIndex: "impressions",
            width: 170,
            key: "impressions",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            hidden: !colvis["impressions"],
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === undefined || data === null) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                {addCommasToNumber(data)}
                            </>
                        }
                    </>
                )
            },
        },
        {
            title:
                <>

                    <span >
                        GIVT Ad Count
                        {columnPartialData ?
                            <Tooltip
                                title={`Partial Data (${columnTimeData})`}
                            >
                                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                            </Tooltip>

                            :
                            <Tooltip
                                title={`Complete Data (${columnTimeData})`}
                            >
                                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                            </Tooltip>
                        }
                    </span>


                </>,
            dataIndex: "givtImpressions",
            width: 170,
            key: "givtImpressions",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            hidden: !colvis["givtImpressions"],
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === undefined || data === null) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtImpsRate)}%)</span>}
                            </>
                        }
                    </>
                )
            },
        },
        {
            title:
                <>

                    <span >
                        SIVT Ad Count
                        {columnPartialData ?
                            <Tooltip
                                title={`Partial Data (${columnTimeData})`}
                            >
                                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                            </Tooltip>
                            :
                            <Tooltip
                                title={`Complete Data (${columnTimeData})`}
                            >
                                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                            </Tooltip>
                        }
                    </span>


                </>,
            dataIndex: "sivtImpressions",
            width: 170,
            key: "sivtImpressions",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            hidden: !colvis["sivtImpressions"],
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === undefined || data === null) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.sivtImpsRate)}%)</span>}
                            </>
                        }
                    </>
                )
            },
        },
        {
            title: <>

                <span >
                    IVT
                    {columnPartialData ?
                        <Tooltip
                            title={`Partial Data (${columnTimeData})`}
                        >
                            <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                        </Tooltip>
                        :
                        <Tooltip
                            title={`Complete Data (${columnTimeData})`}
                        >
                            <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                        </Tooltip>
                    }
                </span>


            </>,
            dataIndex: "givtSivtImp",
            width: 160,
            key: "givtSivtImp",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            hidden: !colvis["givtSivtImp"],
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === undefined || data === null) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtSivtRate)}%)</span>}
                            </>
                        }
                    </>
                )
            },
        },
        {
            title:
                <>

                    <span >
                        Net Viewability
                        {columnPartialData ?
                            <Tooltip
                                title={`Partial Data (${columnTimeData})`}
                            >
                                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                            </Tooltip>
                            :
                            <Tooltip
                                title={`Complete Data (${columnTimeData})`}
                            >
                                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                            </Tooltip>
                        }
                    </span>



                </>,
            dataIndex: "viewability",
            width: 150,
            key: "viewability",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            hidden: !colvis["viewability"],
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === undefined || data === null) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                {addCommasToNumber(data)} %
                            </>
                        }
                    </>
                )
            },
        },
        {
            title:
                <>

                    <span >
                        Discrepancies
                        {columnPartialData ?
                            <Tooltip
                                title={`Partial Data (${columnTimeData})`}
                            >
                                <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                            </Tooltip>

                            :
                            <Tooltip
                                title={`Complete Data (${columnTimeData})`}
                            >
                                <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                            </Tooltip>
                        }
                    </span>

                </>,
            dataIndex: "discrep",
            width: 150,
            key: "discrep",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            hidden: !colvis["discrep"],
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === undefined || data === null) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
                            </>
                        }
                    </>
                )
            },
        },
        {
            title: "Updated At (UTC)",
            dataIndex: "pix_updatedAt",
            width: 150,
            key: "pix_updatedAt",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            hidden: !colvis["pix_updatedAt"],
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === undefined || data === null) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                {data}
                            </>
                        }
                    </>
                )
            },
        },


    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });



    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")





    const [filterShow, setFilterShow] = useState(false)

    const [filterPublishers, setFilterPublisher] = useState([])

    useEffect(() => {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            if (checkRole !== "admin") {
                axios
                    .get(configData.SERVER_URL + "zone/pubMinifiedList", {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    })
                    .then((response) => {
                        setFilterPublisher(response.data.data);
                    })
                    .catch((error) => { });
            }
        }
    }, []);


    const getLabels = (values) => {
        return values.map(value => {
            const publisher = filterPublishers.find(publisher => publisher.value === value);
            return publisher ? publisher.label : value;
        }).join(", ");
    };


    const [filterApply, setFilterApply] = useState({
        status: [],
        categoryType: [],
        integrationType: [],
        publisher: []
    });
    const [filterApplyApiCall, setFilterApplyApiCall] = useState({
        status: [],
        categoryType: [],
        integrationType: [],
        publisher: []
    });

    useEffect(() => {
        if (!initialLoad) {
            let tempPage = page
            tempPage.current = 1
            setPage(tempPage);
            setApicall(!apiCall)
        }

    }, [filterApplyApiCall])

    function handleFilterApply(type, value) {
        let tempFilterApply = { ...filterApply }
        if (type === "status") {
            // tempFilterApply.status = [value]
            const index = filterApply.status.indexOf(value);
            if (index === -1) {
                tempFilterApply.status.push(value);
            } else {
                tempFilterApply.status.splice(index, 1);
            }

        }
        if (type === "categoryType") {
            const index = filterApply.categoryType.indexOf(value);
            if (index === -1) {
                tempFilterApply.categoryType.push(value);
            } else {
                tempFilterApply.categoryType.splice(index, 1);
            }

        }

        if (type === "integrationType") {
            const index = filterApply.integrationType.indexOf(value);
            if (index === -1) {
                tempFilterApply.integrationType.push(value);
            } else {
                tempFilterApply.integrationType.splice(index, 1);
            }

        }

        if (type === "publisher") {

            let newValue = [];
            if (tempFilterApply.publisher.includes(value)) {
                newValue = tempFilterApply.publisher.filter((item) => item !== value);
            } else {
                newValue = [...tempFilterApply.publisher, value];
            }
            tempFilterApply.publisher = newValue

        }

        setFilterApply(tempFilterApply)

    }

    const dropdownRef = useRef(null);



    // Use a ref to track the current state of filterShow
    const filterShowRef = useRef(filterShow);

    useEffect(() => {
        // Update the ref whenever filterShow changes
        filterShowRef.current = filterShow;
    }, [filterShow]);

    useEffect(() => {
        // Function to handle clicks outside the dropdown
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                filterShowRef
            ) {

                const selectElement = document.getElementById('adcodeSelect'); // assuming this is the parent of the actual dropdown
                if (!selectElement?.closest('.ant-select')?.classList?.contains('ant-select-open')) {

                    let temp = JSON.parse(JSON.stringify(filterApplyApiCall));

                    setFilterApply(prevState => ({
                        ...prevState,
                        status: temp.status,
                        categoryType: temp.categoryType,
                        integrationType: temp.integrationType,
                        publisher: temp.publisher
                    }));

                    setFilterShow(false);
                }
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // }, [dropdownRef, filterShow, filterApplyApiCall, setFilterApply, setFilterShow]);
    });

    const getDataInitial = () => {
        setLoading(true)


        // let tempFilter = { ...filterApplyApiCall }

        if (publisherfromPublisherList) {
            // if (!tempFilter.publisher.includes(publisherfromPublisherList)) {
            //     tempFilter.publisher.push(publisherfromPublisherList);
            // }
            setFilterApply({
                status: [],
                categoryType: [],
                integrationType: [],
                publisher: [publisherfromPublisherList]
            })
            setFilterApplyApiCall({
                status: [],
                categoryType: [],
                integrationType: [],
                publisher: [publisherfromPublisherList]
            })

        }

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .post(configData.SERVER_URL + `zone/zoneListing?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`, {
                    // filter: filterApplyApiCall
                    filter: {
                        status: [],
                        categoryType: [],
                        integrationType: [],
                        publisher: publisherfromPublisherList ? [publisherfromPublisherList] : []
                    }
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setData(response.data.data.data)
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.metaData?.totalRecords

                        setPage(tempPage)
                        setColumnPartialData(response.data.partial)
                        setColumnTimeData(response.data.pix_updatedAt)
                    }
                    else {
                        setColumnPartialData(false)
                        setColumnTimeData("")
                    }


                    // setTimeout(() => {
                    setLoading(false)
                    // }, 300)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                    setColumnPartialData(false)
                    setColumnTimeData("")
                });
        }

    }


    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .post(configData.SERVER_URL + `zone/zoneListing?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`, {
                    filter: filterApplyApiCall
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setData(response.data.data.data)
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.metaData?.totalRecords

                        setPage(tempPage)
                        setColumnPartialData(response.data.partial)
                        setColumnTimeData(response.data.pix_updatedAt)
                    }
                    else {
                        setColumnPartialData(false)
                        setColumnTimeData("")
                    }


                    // setTimeout(() => {
                    setLoading(false)
                    // }, 300)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                    setColumnPartialData(false)
                    setColumnTimeData("")
                });
        }

    }

    // Function to convert JSON to CSV
    const convertToCSV = (data, headers) => {
        const csvRows = [];
        // Create header row
        const headerRow = headers.map(header => header.label).join(",");
        csvRows.push(headerRow);
        // Create data rows
        data.forEach(row => {
            const rowData = headers.map(header => {
                let value = row[header.key] ?? ""; // Use empty string if value is undefined/null
                if (header.key === "status") {
                    value = value === true ? "Enabled" : "Disabled";
                }

                if (header.key === "z_cate") {
                    value = value === "vast_aniview" ? "Vast (Aniview)" : value === "Vast Zone" ? "Vast (ADK)" : value === "Player Tag" ? "Player Tag (Instream)" : value === "tag_outstream" ? "Player Tag (Outstream)" : value;
                }

                if (header.key === "givtImpressions") {
                    const givtImpsRate = row["givtImpsRate"] ?? 0; // Default to 0 if undefined
                    if (value !== "0") {
                        value = `${value} (${givtImpsRate}%)`;
                    }
                }

                if (header.key === "sivtImpressions") {
                    const sivtImpsRate = row["sivtImpsRate"] ?? 0; // Default to 0 if undefined
                    if (value !== "0") {
                        value = `${value} (${sivtImpsRate}%)`;
                    }
                }

                if (header.key === "givtSivtImp") {
                    const givtSivtRate = row["givtSivtRate"] ?? 0; // Default to 0 if undefined
                    if (value !== "0") {
                        value = `${value} (${givtSivtRate}%)`;
                    }
                }

                if (header.key === "viewability") {
                    if (value !== undefined) {
                        value = `${value}% `
                    }
                }

                return `"${String(value).replace(/"/g, '""')}"`; // Escape double quotes
            });
            csvRows.push(rowData.join(","));
        });
        return csvRows.join("\n");
    };

    const getDataExport = () => {
        setExportLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .post(configData.SERVER_URL + `zone/zoneListing?sort=${sort.name}&order=${sort.type}&search=${search}&limit=100000&page=1`, {
                    filter: filterApplyApiCall
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    const keptArray = exportHeader.filter(item => colvis[item.key] !== false);
                    const formattedCSV = convertToCSV(response.data.data.data, keptArray);

                    // Convert to blob and download
                    const blob = new Blob([formattedCSV], { type: "text/csv;charset=utf-8;" });
                    saveAs(blob, "Zones_" + new Date().getTime() + ".csv");
                    setExportLoading(false)
                })
                .catch((error) => {
                    notifyfailure("Failed to export zone list");
                    setExportLoading(false)
                });
        }
    }

    useEffect(() => {
        TokenVerificationLoggedin();
        ScreenView()
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setCheckRole(checkRole)
        }
        getDataInitial()
        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);



    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }

        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };

    const handlePageView = (data) => {
        setPageView(data)

    }

    const handlePageViewEdit = (data, reload) => {
        if (reload === "yes") {
            setApicall(!apiCall)
        }
        setZoneViewId("")
        setZoneViewName("")
        setZoneCategory("")
        setPageView(data)

    }


    // //////////////////////////////////////////////////Modal related States///////////////////////////////

    const [formTypeList, setFormTypeList] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [activeKey, setActiveKey] = useState('1');
    const onTabChange = (key) => {
        setActiveKey(key);
    };
    const [dataModal_prebid, setDataModal_prebid] = useState({
        "hostInfo": [],
        "userSyncTag": []
    });
    const [dataModal_openrtb, setDataModal_openrtb] = useState({
        "urlTemplate": [],
        "userSyncTag": []
    });
    const [dataModal_vastzone, setDataModal_vastzone] = useState({
        "userSyncTag": []
    });
    const [dataModal_vast_aniview, setDataModal_vast_aniview] = useState({
        "userSyncTag": []
    });
    const [dataModal_playertag, setDataModal_playertag] = useState({
        "userSyncTag": []
    });
    const [dataModal_gamtag, setDataModal_gamtag] = useState({
        "userSyncTag": []
    });

    function resetModalStateZoneInfo() {
        setIsModalVisible(false);
        setFormTypeList("");
        setActiveKey('1');
        setDataModal_prebid({
            "hostInfo": [],
            "userSyncTag": []
        });
        setDataModal_openrtb({
            "urlTemplate": [],
            "userSyncTag": []
        });
        setDataModal_vastzone({
            "userSyncTag": []
        });
        setDataModal_vast_aniview({
            "userSyncTag": []
        });
        setDataModal_playertag({
            "userSyncTag": []
        });
        setDataModal_gamtag({
            "userSyncTag": []
        });

    }

    // function copyToClipboard(textToCopy) {
    //     navigator.clipboard
    //         .writeText(textToCopy)
    //         .then(() => { })
    //         .catch((err) => { });
    // }


    const [tooltipContent, setTooltipContent] = useState("Click to copy")

    function copyToClipboard(text) {
        // Check if the Clipboard API is supported
        if (navigator.clipboard && navigator.clipboard.writeText) {
            // Use Clipboard API to copy text to clipboard
            navigator.clipboard.writeText(text)
                .then(() => {
                    // console.log("Text copied to clipboard successfully: " + text);
                })
                .catch((error) => {
                    // console.error("Unable to copy text to clipboard: ", error);
                });
        } else {
            // Fallback method if Clipboard API is not supported
            var tempInput = document.createElement("input");
            tempInput.setAttribute("value", text);
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);
            // console.log("Text copied to clipboard successfully (fallback method): " + text);
        }

        setTooltipContent("Copied");

        setTimeout(() => {
            setTooltipContent("Click to copy");
        }, 1000);
    }



    const items_prebid = [
        {
            key: '1', tab: 'User Sync Tag',
            content: (
                <>
                    <div className='d-flex justify-content-between'>
                        <label className='form_label'>Iframe</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link ><img src={copyIcon}
                                onClick={() => { copyToClipboard(Array.isArray(dataModal_prebid.userSyncTag) ? dataModal_prebid.userSyncTag.length === 2 ? dataModal_prebid.userSyncTag[0].value : "" : "") }}
                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item">
                        <div className="primary text">
                            {Array.isArray(dataModal_prebid.userSyncTag) ? dataModal_prebid.userSyncTag.length === 2 ? dataModal_prebid.userSyncTag[0].value : "" : ""}
                        </div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <label className='form_label'>Image</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link ><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_prebid.userSyncTag) ? dataModal_prebid.userSyncTag.length === 2 ? dataModal_prebid.userSyncTag[1].value : "" : ""
                                    )
                                }
                                }
                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item">
                        <div className="primary text">
                            {Array.isArray(dataModal_prebid.userSyncTag) ? dataModal_prebid.userSyncTag.length === 2 ? dataModal_prebid.userSyncTag[1].value : "" : ""}
                        </div>
                    </div>

                    <div className='adding_new_parameters'>
                        <div className='d-flex align-items-start justify-content-between'>
                            <label className='form_label'>Parameters</label>

                        </div>
                    </div>
                    <div className='all_parameters--text'>
                        <ul className='m-0 p-0'>
                            <li>
                                <h4 className='parameters_heading'>SSP_REDIR_URL</h4>
                                <span className='parameters_text'>Up to 128 alphanumeric and special characters is allowed: [0-9A-Za-z._-]. The zone is allowed to have up to 2,000 distinct subids per day. You will be able to view statistics for each subid.</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>gdpr</h4>
                                <span className='parameters_text'>specifies if GDPR applies for current user (0 or 1).</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>gdpr_consent</h4>
                                <span className='parameters_text'>URL-encoded Base64-encoded consent string as per IAB specification.</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>us_privacy</h4>
                                <span className='parameters_text'>URL-encoded U.S. Privacy string.</span>
                            </li>
                        </ul>
                    </div>
                </>
            )
        },
        {
            key: '2', tab: 'Prebid Details', content: (
                <>

                    <div className='d-flex justify-content-between'>
                        <label className='form_label'>Zone Id</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link ><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_prebid.hostInfo) ? dataModal_prebid.hostInfo.length === 2 ? dataModal_prebid.hostInfo[0].value : "" : ""
                                    )
                                }
                                }
                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item">
                        <div className="dark text">
                            {Array.isArray(dataModal_prebid.hostInfo) ? dataModal_prebid.hostInfo.length === 2 ? dataModal_prebid.hostInfo[0].value : "" : ""}
                        </div>
                    </div>

                    <div className='d-flex justify-content-between'>
                        <label className='form_label'>Host name</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link ><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_prebid.hostInfo) ? dataModal_prebid.hostInfo.length === 2 ? dataModal_prebid.hostInfo[1].value : "" : ""
                                    )
                                }
                                }
                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item">
                        <div className="dark text">
                            {Array.isArray(dataModal_prebid.hostInfo) ? dataModal_prebid.hostInfo.length === 2 ? dataModal_prebid.hostInfo[1].value : "" : ""}
                        </div>
                    </div>

                </>
            )
        },
    ];


    const items_openrtb = [
        {
            key: '1',
            tab: 'URL Template',
            content: (
                <>
                    <div className='d-flex justify-content-between'>
                        <label className='form_label'> US East (New York)</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link className="download_icon download_icon_d2"><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[0].value : "" : ""
                                    )
                                }
                                }

                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item">
                        <div className="primary text">
                            {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[0].value : "" : ""}
                        </div>
                    </div>

                    <div className='d-flex justify-content-between'>
                        <label className='form_label'>  US West (Los Angeles)</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link className="download_icon download_icon_d2"><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[1].value : "" : ""
                                    )
                                }
                                }
                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item">
                        <div className="primary text">
                            {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[1].value : "" : ""}
                        </div>
                    </div>


                    <div className='d-flex justify-content-between'>
                        <label className='form_label'> EU (Amsterdam, NL)</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link className="download_icon download_icon_d2"><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[2].value : "" : ""
                                    )
                                }
                                }
                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item">
                        <div className="primary text">
                            {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[2].value : "" : ""}
                        </div>
                    </div>


                    <div className='d-flex justify-content-between'>
                        <label className='form_label'>  APAC (Singapore)</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link className="download_icon download_icon_d2"><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[3].value : "" : ""
                                    )
                                }
                                }
                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item">
                        <div className="primary text">
                            {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[3].value : "" : ""}
                        </div>
                    </div>


                </>
            )
        },
        {
            key: '2', tab: 'User Sync Tag',
            content: (
                <>
                    <div className='d-flex justify-content-between'>
                        <label className='form_label'>Iframe</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link className="download_icon download_icon_d2"><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_openrtb?.userSyncTag) ? dataModal_openrtb?.userSyncTag.length === 2 ? dataModal_openrtb?.userSyncTag[0].value : "" : ""
                                    )
                                }
                                }
                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item">
                        <div className="primary text">
                            {Array.isArray(dataModal_openrtb?.userSyncTag) ? dataModal_openrtb?.userSyncTag.length === 2 ? dataModal_openrtb?.userSyncTag[0].value : "" : ""}
                        </div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <label className='form_label'>Image</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link className="download_icon download_icon_d2"><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_openrtb?.userSyncTag) ? dataModal_openrtb?.userSyncTag.length === 2 ? dataModal_openrtb?.userSyncTag[1].value : "" : ""
                                    )
                                }
                                }
                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item">
                        <div className="primary text">
                            {Array.isArray(dataModal_openrtb?.userSyncTag) ? dataModal_openrtb?.userSyncTag.length === 2 ? dataModal_openrtb?.userSyncTag[1].value : "" : ""}
                        </div>
                    </div>
                    <div className='adding_new_parameters'>
                        <div className='d-flex align-items-start justify-content-between'>
                            <label className='form_label'>Parameters</label>
                            <small className='info_text--d2-orange'>*All parameters should be URL-encoded</small>
                        </div>
                    </div>
                    <div className='all_parameters--text'>
                        <ul className='m-0 p-0'>
                            <li>
                                <h4 className='parameters_heading'>SSP_REDIR_URL</h4>
                                <span className='parameters_text'>Up to 128 alphanumeric and special characters is allowed: [0-9A-Za-z._-]. The zone is allowed to have up to 2,000 distinct subids per day. You will be able to view statistics for each subid.</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>gdpr</h4>
                                <span className='parameters_text'>specifies if GDPR applies for current user (0 or 1).</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>gdpr_consent</h4>
                                <span className='parameters_text'>URL-encoded Base64-encoded consent string as per IAB specification.</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>us_privacy</h4>
                                <span className='parameters_text'>URL-encoded U.S. Privacy string.</span>
                            </li>
                        </ul>
                    </div>
                </>
            )
        },
    ];

    const items_vastzone = [
        {
            key: '1', tab: 'URL Template',
            content: (
                <>
                    <div className='d-flex justify-content-between'>
                        <label className='form_label'>Vast ADK Tag</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link className="download_icon download_icon_d2"><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_vastzone.userSyncTag) ? dataModal_vastzone.userSyncTag.length === 1 ? dataModal_vastzone.userSyncTag[0].value : "" : ""
                                    )
                                }
                                }
                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item">
                        <div className="primary text">
                            {Array.isArray(dataModal_vastzone.userSyncTag) ? dataModal_vastzone.userSyncTag.length === 1 ? dataModal_vastzone.userSyncTag[0].value : "" : ""}

                        </div>
                    </div>
                    <div className='adding_new_parameters'>
                        <div className='d-flex align-items-start justify-content-between'>
                            <label className='form_label'>Parameters</label>
                            <small className='info_text--d2-orange'>*All parameters should be URL-encoded</small>
                        </div>
                    </div>
                    <div className='all_parameters--text'>
                        <ul className='m-0 p-0'>
                            <li>
                                <h4 className='parameters_heading'>subid</h4>
                                <span className='parameters_text'>Up to 128 alphanumeric and special characters is allowed: [0-9A-Za-z._-]. The zone is allowed to have up to 2,000 distinct subids per day. You will be able to view statistics for each subid.</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>page_url</h4>
                                <span className='parameters_text'>URL of the page where ads will be displayed.</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>w</h4>
                                <span className='parameters_text'>Video player width.</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>h</h4>
                                <span className='parameters_text'>Video player height.</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>startdelay</h4>
                                <span className='parameters_text'>Indicates the start delay in seconds for preroll, midroll, or postroll ad placement. If the start delay value is
                                    greater than 0 then the position is mid-roll, and the value represents the number of seconds into the content that
                                    the ad will be displayed. If the start delay time is not available, you can report the position of the ad in general terms
                                    using negative numbers:
                                    <br /> 0 - Pre-roll
                                    <br /> -1 - Generic mid-roll
                                    <br /> -2 - Generic Post-roll</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>linearity</h4>
                                <span className='parameters_text'>Indicates the type of an ad impression: “linear”(default) and “overlay”.</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>ip</h4>
                                <span className='parameters_text'>IP address of the visitor.</span>
                            </li>
                            <li>
                                <h4 className='parameters_heading'>ua</h4>
                                <span className='parameters_text'>User-Agent header from visitor's HTTP request.</span>
                            </li>
                        </ul>
                    </div>
                </>
            )
        }
    ];

    const items_vast_aniview = [
        {
            key: '1', tab: 'URL Template',
            content: (
                <>

                    <div className='d-flex justify-content-between'>
                        <label className='form_label'>Vast Aniview Tag</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link className="download_icon download_icon_d2"><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_vast_aniview.userSyncTag) ? dataModal_vast_aniview.userSyncTag.length === 1 ? dataModal_vast_aniview.userSyncTag[0].value : "" : ""
                                    )
                                }
                                }

                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item" style={{ height: "auto" }}>
                        <div className="primary text">
                            {Array.isArray(dataModal_vast_aniview.userSyncTag) ? dataModal_vast_aniview.userSyncTag.length === 1 ? dataModal_vast_aniview.userSyncTag[0].value : "" : ""}
                        </div>
                    </div>

                </>
            )
        }
    ];

    const items_playertag = [
        {
            key: '1', tab: 'URL Template',
            content: (
                <>

                    <div className='d-flex justify-content-between'>
                        <label className='form_label'>Player Tag</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link className="download_icon download_icon_d2"><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_playertag.userSyncTag) ? dataModal_playertag.userSyncTag.length === 1 ? dataModal_playertag.userSyncTag[0].value : "" : ""
                                    )
                                }
                                }

                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item" style={{ height: "auto" }}>
                        <div className="primary text">
                            {Array.isArray(dataModal_playertag.userSyncTag) ? dataModal_playertag.userSyncTag.length === 1 ? dataModal_playertag.userSyncTag[0].value : "" : ""}
                        </div>
                    </div>

                </>
            )
        }
    ];

    const items_gamtag = [
        {
            key: '1', tab: 'URL Template',
            content: (
                <>

                    <div className='d-flex justify-content-between'>
                        <label className='form_label'>Vast Tag</label>
                        <Tooltip overlayInnerStyle={{ minWidth: '100px', textAlign: 'center' }} title={tooltipContent}>
                            <Link className="download_icon download_icon_d2"><img src={copyIcon}
                                onClick={() => {
                                    copyToClipboard(
                                        Array.isArray(dataModal_gamtag.userSyncTag) ? dataModal_gamtag.userSyncTag.length === 1 ? dataModal_gamtag.userSyncTag[0].value : "" : ""
                                    )
                                }
                                }

                                alt='Copy Icon' /></Link>
                        </Tooltip>
                    </div>
                    <div className="select_item" style={{ height: "auto" }}>
                        <div className="primary text">
                            {Array.isArray(dataModal_gamtag.userSyncTag) ? dataModal_gamtag.userSyncTag.length === 1 ? dataModal_gamtag.userSyncTag[0].value : "" : ""}
                        </div>
                    </div>

                </>
            )
        }
    ];



    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :

                    (filterApplyApiCall.publisher.length > 0 || filterApplyApiCall.status.length > 0 || filterApplyApiCall.categoryType.length > 0 || filterApplyApiCall.integrationType.length > 0) && loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        (filterApplyApiCall.publisher.length > 0 || filterApplyApiCall.status.length > 0 || filterApplyApiCall.categoryType.length > 0 || filterApplyApiCall.integrationType.length > 0) && !loading ?
                            <div className='no_data_screen'>
                                <div className='text-center'>
                                    <img src={errorData} className='' alt="" />
                                    <div className='float_text_div'>

                                    </div>
                                </div>
                            </div>
                            :

                            loading ?
                                <div className='no_data_screen'>
                                    <div className='text-center'>

                                        <div className='float_text_div'>

                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='no_data_screen' >
                                    <div className='text-center'>
                                        <img src={noData} className='' alt="" />
                                        <div className='float_text_div'>

                                        </div>
                                    </div>
                                </div>
            }
            </>

    };

    const components = {
        header: {
            wrapper: (props) => (
                <thead {...props}>
                    {props.children}
                </thead>
            ),
        },

        body: {
            wrapper: (props) => (
                <tbody {...props}>
                    {loading ? (
                        <>
                            <div className='loader_top_space'>
                                <div className="inside_table_two_loader">
                                    <img src={FullLoader} className="" alt="" />
                                </div>
                            </div>


                        </>
                    ) : (
                        props.children
                    )}
                </tbody>
            ),
        },
    };


    ///////////////////////////tej code //////////////////////

    // const [show, setShow] = useState(false);


    // const handleToggle = () => setShow(!show);
    // const handleClose = () => setShow(false);

    // const handleApplyClick = () => {
    //     // Your apply logic here
    //     handleClose();
    // };

    // const handleResetClick = () => {
    //     // Your reset logic here
    //     handleClose();
    // };


    // const [value, setValue] = useState(['a10', 'c12', 'h17', 'j19', 'k20']);

    // const handleOptionClick = (optionValue) => {
    //     setValue((prevValue) => {
    //         if (prevValue.includes(optionValue)) {
    //             return prevValue.filter((item) => item !== optionValue);
    //         } else {
    //             return [...prevValue, optionValue];
    //         }
    //     });
    // };

    // const options = [];
    // for (let i = 10; i < 36; i++) {
    //     const value = i.toString(36) + i;
    //     options.push({
    //         label: `Long Label: ${value}`,
    //         value,
    //     });
    // }

    // const sharedProps = {
    //     mode: 'multiple',
    //     placeholder: 'Select Item...',
    //     maxTagCount: 'responsive',
    // };


    const [searchValue, setSearchValue] = useState('');

    const handleSearch = (e) => {
        setSearchValue(e.target.value.toLowerCase());
    };

    const filteredOptions = filterPublishers.filter(option =>
        option.label.toLowerCase().includes(searchValue)
    );

    return (
        <>


            <div className="container_box--wrapper pt_header"
                style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        Zones
                    </h1>

                    <div className="btn_group">
                        {!initialLoad &&
                            <>
                                {checkRole !== "admin" &&
                                    <button className='btn btn_outline--grey w_fit_content md'
                                        onClick={() => { setPageView("import") }}
                                    ><span><img src={importDarkIcon} alt='USP' /> Import</span></button>
                                }
                                <button className='btn btn_primary w_fit_content md'
                                    onClick={() => { setPageView("create") }}
                                ><span><img src={addIcon} alt='USP' /> New Zone</span></button>
                            </>}
                    </div>

                </div>
                <div className="d_flex justify_content_between  mb_10">
                    <div className="form_content_block--group">
                        {!initialLoad &&
                            <Input
                                type='text'
                                className='form_control basic md search_input w_table_search'
                                placeholder="Search"
                                value={search}
                                onChange={(e) => {

                                    if (e.target.value.trim().length === 0) {
                                        setLoading(true)
                                    }

                                    setSearch(e.target.value)
                                }}
                            />
                        }
                    </div>
                    {!initialLoad &&
                        <div className="custom_filter_design_d2">

                            <div className="filter_tags_design_d2">
                                <ul className="p-0 m-0">
                                    {filterApplyApiCall.publisher.length > 0 &&
                                        <li>
                                            <div className="d-flex">
                                                <span className="black_text_d2">Publisher:</span>
                                                {/* {getLabels(filterApplyApiCall.publisher)} */}
                                                {getLabels(filterApplyApiCall.publisher)?.split(',')?.length === 0 ?
                                                    getLabels(filterApplyApiCall.publisher) :
                                                    <>
                                                        <>{getLabels(filterApplyApiCall.publisher)?.split(",")[0]} </>
                                                        {getLabels(filterApplyApiCall.publisher)?.split(",")?.length > 1 && <>  , &nbsp;+{getLabels(filterApplyApiCall.publisher)?.split(",")?.length - 1} ... </>}
                                                    </>}
                                            </div>
                                            <button type="button"><img src={tagRomoveIcon} className="" alt=""
                                                onClick={() => {
                                                    let tempFilterApply = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                    let tempFilterApply2 = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                    tempFilterApply.publisher = []
                                                    tempFilterApply2.publisher = []
                                                    setFilterApply(tempFilterApply2)
                                                    setFilterApplyApiCall(tempFilterApply)
                                                }}
                                            /> </button>
                                        </li>
                                    }

                                    {filterApplyApiCall.status.length > 0 &&
                                        <li>
                                            <div className="d-flex">
                                                <span className="black_text_d2">Status:</span> {filterApplyApiCall.status.join(", ")}
                                            </div>
                                            <button type="button"><img src={tagRomoveIcon} className="" alt=""
                                                onClick={() => {
                                                    let tempFilterApply = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                    let tempFilterApply2 = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                    tempFilterApply.status = []
                                                    tempFilterApply2.status = []
                                                    setFilterApply(tempFilterApply2)
                                                    setFilterApplyApiCall(tempFilterApply)
                                                }}
                                            /> </button>
                                        </li>
                                    }
                                    {filterApplyApiCall.categoryType.length > 0 &&
                                        <li>
                                            <div className="d-flex">
                                                <span className="black_text_d2">Zone Category:</span>
                                                {/* {filterApplyApiCall.categoryType.join(", ")} */}
                                                {filterApplyApiCall.categoryType
                                                    .map(category => {
                                                        if (category === "vast_aniview") return "Vast (Aniview)";
                                                        if (category === "Vast Zone") return "Vast (ADK)";
                                                        if (category === "Player Tag") return "Player Tag (Instream)";
                                                        if (category === "tag_outstream") return "Player Tag (Outstream)";
                                                        return category;
                                                    })
                                                    .join(", ")}
                                            </div>
                                            <button type="button"><img src={tagRomoveIcon} className="" alt=""
                                                onClick={() => {
                                                    let tempFilterApply = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                    let tempFilterApply2 = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                    tempFilterApply.categoryType = []
                                                    tempFilterApply2.categoryType = []
                                                    setFilterApply(tempFilterApply2)
                                                    setFilterApplyApiCall(tempFilterApply)
                                                }}
                                            /> </button>
                                        </li>
                                    }
                                    {filterApplyApiCall.integrationType.length > 0 &&
                                        <li>
                                            <div className="d-flex">
                                                <span className="black_text_d2">Integration Type:</span>{filterApplyApiCall.integrationType.join(", ")}

                                            </div>
                                            <button type="button"><img src={tagRomoveIcon} className="" alt=""
                                                onClick={() => {
                                                    let tempFilterApply = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                    let tempFilterApply2 = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                    tempFilterApply.integrationType = []
                                                    tempFilterApply2.integrationType = []
                                                    setFilterApply(tempFilterApply2)
                                                    setFilterApplyApiCall(tempFilterApply)
                                                }}
                                            /> </button>
                                        </li>
                                    }

                                </ul>
                            </div>

                            <Dropdown ref={dropdownRef} show={filterShow}
                                onToggle={() => { setFilterShow(!filterShow) }}
                                className="" autoClose={false}>
                                <div className="position-relative hover_effec_hide_show_d2">
                                    <Dropdown.Toggle id="dropdown-autoclose-false">
                                        <img src={filterIcon} className="img-fluid" alt="" /> Filter
                                        {filterApplyApiCall?.status?.length + filterApplyApiCall?.categoryType?.length + filterApplyApiCall?.integrationType?.length + filterApplyApiCall?.publisher?.length > 0 &&
                                            <div className="selected_filter_tag_d2">
                                                <div>{filterApplyApiCall?.status?.length + filterApplyApiCall?.categoryType?.length + filterApplyApiCall?.integrationType?.length + filterApplyApiCall?.publisher?.length}</div>
                                            </div>
                                        }
                                    </Dropdown.Toggle>
                                    {filterApplyApiCall?.status?.length + filterApplyApiCall?.categoryType?.length + filterApplyApiCall?.integrationType?.length + filterApplyApiCall?.publisher?.length > 0 &&
                                        <div className="clear_filter_icon_d2">
                                            <button type="button"> <img src={HoverCloseIcon} alt=""
                                                onClick={() => {
                                                    setFilterApply({
                                                        status: [],
                                                        categoryType: [],
                                                        integrationType: [],
                                                        publisher: []
                                                    })
                                                    setFilterApplyApiCall({
                                                        status: [],
                                                        categoryType: [],
                                                        integrationType: [],
                                                        publisher: []
                                                    })
                                                    setFilterShow(false)
                                                }} />
                                            </button>
                                        </div>
                                    }
                                </div>

                                <Dropdown.Menu>
                                    <div className="filter_inner_heading_d2">
                                        {checkRole !== "admin" &&
                                            <>
                                                <div className="d-flex align-items-start justify-content-between">
                                                    <p className="m-0">Publisher</p>
                                                    <button type="button" className="filter_clear_btn"
                                                        onClick={() => {
                                                            let tempFilterApply = { ...filterApply }
                                                            tempFilterApply.publisher = []
                                                            setFilterApply(tempFilterApply)
                                                        }}
                                                    >Reset</button>
                                                </div>
                                                <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100">

                                                    {/* <Select
                                            id="adcodeSelect"
                                            // {...sharedProps}
                                            // value={selectedPublishers}
                                            value={filterApply.publisher}
                                            popupClassName='diff_select_d2'
                                            // onChange={setValue}
                                            placeholder='- Select -'
                                            className="form_select basic error"
                                            mode='multiple'
                                            maxTagCount='responsive'>

                                            {filterPublishers.map(option => (
                                                <Select.Option key={option.value} value={option.value}>
                                                    <div
                                                        // onMouseDown={(e) => e.preventDefault()}
                                                        // onClick={() => handleSelectPublisher(option.value)}
                                                        onClick={() => handleFilterApply("publisher", option.value)}
                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                    >
                                                        <Checkbox
                                                            // checked={selectedPublishers.includes(option.value)}
                                                            checked={filterApply.publisher.includes(option.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            {option.label}
                                                        </Checkbox>
                                                    </div>
                                                </Select.Option>
                                            ))}
                                        </Select> */}


                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic error"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                                <hr />
                                            </>
                                        }



                                        <p className="m-0">Status</p>
                                        <div className="checkbox_value_select_d2">
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="statusenabled" id="statusenabled"
                                                    checked={filterApply.status.includes("Enabled")}
                                                    onChange={() => { handleFilterApply("status", "Enabled") }}
                                                />
                                                <label htmlFor="statusenabled" className="single_checkbox_select_d2">
                                                    Enabled
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="statusdisabled" id="statusdisabled"
                                                    checked={filterApply.status.includes("Disabled")}
                                                    onChange={() => { handleFilterApply("status", "Disabled") }}
                                                />
                                                <label htmlFor="statusdisabled" className="single_checkbox_select_d2">
                                                    Disabled
                                                </label>
                                            </div>
                                        </div>
                                        <hr />

                                        <p className="m-0">Zone Category</p>
                                        <div className="checkbox_value_select_d2">
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="categoryopenrtb" id="categoryopenrtb"
                                                    checked={filterApply.categoryType.includes("Open RTB")}
                                                    onChange={() => { handleFilterApply("categoryType", "Open RTB") }}
                                                />
                                                <label htmlFor="categoryopenrtb" className="single_checkbox_select_d2">
                                                    OpenRTB
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="categoryprebid" id="categoryprebid"
                                                    checked={filterApply.categoryType.includes("Prebid")}
                                                    onChange={() => { handleFilterApply("categoryType", "Prebid") }}
                                                />
                                                <label htmlFor="categoryprebid" className="single_checkbox_select_d2">
                                                    Prebid
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="categoryvastzone" id="categoryvastzone"
                                                    checked={filterApply.categoryType.includes("Vast Zone")}
                                                    onChange={() => { handleFilterApply("categoryType", "Vast Zone") }}
                                                />
                                                <label htmlFor="categoryvastzone" className="single_checkbox_select_d2">
                                                    VAST (ADK)
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="categoryvastaniview" id="categoryvastaniview"
                                                    checked={filterApply.categoryType.includes("vast_aniview")}
                                                    onChange={() => { handleFilterApply("categoryType", "vast_aniview") }}
                                                />
                                                <label htmlFor="categoryvastaniview" className="single_checkbox_select_d2">
                                                    VAST (Aniview)
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="categorygamtag" id="categorygamtag"
                                                    checked={filterApply.categoryType.includes("GAM Tag")}
                                                    onChange={() => { handleFilterApply("categoryType", "GAM Tag") }}
                                                />
                                                <label htmlFor="categorygamtag" className="single_checkbox_select_d2">
                                                    GAM Tag
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="categoryplayertag" id="categoryplayertag"
                                                    checked={filterApply.categoryType.includes("Player Tag")}
                                                    onChange={() => { handleFilterApply("categoryType", "Player Tag") }}
                                                />
                                                <label htmlFor="categoryplayertag" className="single_checkbox_select_d2">
                                                    Player Tag (Instream)
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="categoryplayertag2" id="categoryplayertag2"
                                                    checked={filterApply.categoryType.includes("tag_outstream")}
                                                    onChange={() => { handleFilterApply("categoryType", "tag_outstream") }}
                                                />
                                                <label htmlFor="categoryplayertag2" className="single_checkbox_select_d2">
                                                    Player Tag (Outstream)
                                                </label>
                                            </div>
                                        </div>
                                        <hr />
                                        <p className="m-0">Inventory Type</p>
                                        <div className="checkbox_value_select_d2">
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="integrationinapp" id="integrationinapp"
                                                    checked={filterApply.integrationType.includes("Inapp")}
                                                    onChange={() => { handleFilterApply("integrationType", "Inapp") }}
                                                />
                                                <label htmlFor="integrationinapp" className="single_checkbox_select_d2">
                                                    Inapp
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="integrationctv" id="integrationctv"
                                                    checked={filterApply.integrationType.includes("CTV")}
                                                    onChange={() => { handleFilterApply("integrationType", "CTV") }}
                                                />
                                                <label htmlFor="integrationctv" className="single_checkbox_select_d2">
                                                    CTV
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="integrationwebsite" id="integrationwebsite"
                                                    checked={filterApply.integrationType.includes("Website")}
                                                    onChange={() => { handleFilterApply("integrationType", "Website") }} />
                                                <label htmlFor="integrationwebsite" className="single_checkbox_select_d2">
                                                    Website
                                                </label>
                                            </div>

                                        </div>

                                        {/* <p className="m-0">ADCODE</p>
                                    <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100">

                                        <Select
                                            {...sharedProps}
                                            value={value}
                                            onChange={setValue}
                                            placeholder='- Select -'
                                            // defaultOpen={true}
                                            // Open={true}
                                            className="form_select basic error"
                                        >
                                            {options.map(option => (
                                                <Select.Option key={option.value} value={option.value}>
                                                    <div
                                                        onMouseDown={(e) => e.preventDefault()}
                                                        onClick={() => handleOptionClick(option.value)}
                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                    >
                                                        <Checkbox
                                                            checked={value.includes(option.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            {option.label}
                                                        </Checkbox>
                                                    </div>
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </div> */}
                                        <hr />
                                    </div>
                                    <div className="filter_bottom_btns_d2 text-end">
                                        <button className="reset" type='button' onClick={() => {
                                            setFilterApply({
                                                status: [],
                                                categoryType: [],
                                                integrationType: [],
                                                publisher: []
                                            })
                                            setFilterApplyApiCall({
                                                status: [],
                                                categoryType: [],
                                                integrationType: [],
                                                publisher: []
                                            })
                                            setFilterShow(false)
                                            setSearchValue('')
                                        }}>Reset</button>
                                        <button className="apply" type='button'
                                            onClick={() => {
                                                let tempdata = JSON.parse(JSON.stringify(filterApply));
                                                setFilterApplyApiCall(tempdata)
                                                setFilterShow(false)
                                                setSearchValue('')
                                            }}
                                            disabled={JSON.stringify(filterApplyApiCall) === JSON.stringify(filterApply)}
                                        >Apply</button>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>

                            <div className="export_btn_hover_d2">
                                {data.length === 0 ?
                                    <Button
                                        className="export_btn_d2"
                                    >
                                        <img src={mediaKitIcon} alt='' />
                                        Export
                                    </Button>
                                    :
                                    <>
                                        {exportLoading ?
                                            <Button
                                                className="export_btn_d2"
                                            >
                                                <img
                                                    src={FullLoader}
                                                    alt="USP"
                                                    height={15}
                                                    width={15}
                                                    className="loader_icon"
                                                />
                                                Export
                                            </Button>
                                            :
                                            <Button
                                                className="export_btn_d2"
                                                onClick={getDataExport}
                                            >
                                                <img src={mediaKitIcon} alt='' />
                                                Export
                                            </Button>
                                        }
                                    </>
                                }
                            </div>

                            <div className="column_hide_unhide_d2">
                                <Dropdown className="" autoClose="outside">
                                    <Dropdown.Toggle id="dropdown-autoclose-outside">
                                        <img src={columnIcon} alt="" />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="colunm_checkbox">
                                            <ul className="p-0 m-0">
                                                {/* <li>
                                                <label htmlFor="seven">
                                                    <input className="form-check-input" type="checkbox" id="seven"
                                                        checked
                                                        disabled

                                                    /> <span>Status</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label htmlFor="six">
                                                    <input className="form-check-input" type="checkbox" id="six"
                                                        checked
                                                        disabled

                                                    /> <span>Zone Id</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label htmlFor="five">
                                                    <input className="form-check-input" type="checkbox" id="five"
                                                        checked
                                                        disabled

                                                    /> <span>Zone Name</span>
                                                </label>
                                            </li> */}
                                                <li>
                                                    <label htmlFor="oneone">
                                                        <input className="form-check-input" type="checkbox" id="oneone"
                                                            checked={colvis.z_cate}
                                                            onChange={() => {
                                                                let tempData = { ...colvis }
                                                                tempData.z_cate = !tempData.z_cate
                                                                setColvis(tempData)
                                                            }}
                                                        /> <span>Category</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label htmlFor="twotwo">
                                                        <input className="form-check-input" type="checkbox" id="twotwo"
                                                            checked={colvis.invent_type}
                                                            onChange={() => {
                                                                let tempData = { ...colvis }
                                                                tempData.invent_type = !tempData.invent_type
                                                                setColvis(tempData)
                                                            }}
                                                        /> <span>Inventory Type</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label htmlFor="three-one">
                                                        <input className="form-check-input" type="checkbox" id="three-one"
                                                            checked={colvis.p_adkId}
                                                            onChange={() => {
                                                                let tempData = { ...colvis }
                                                                tempData.p_adkId = !tempData.p_adkId
                                                                setColvis(tempData)
                                                            }}
                                                        /> <span>Publisher Id</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label htmlFor="three">
                                                        <input className="form-check-input" type="checkbox" id="three"
                                                            checked={colvis.p_name}
                                                            onChange={() => {
                                                                let tempData = { ...colvis }
                                                                tempData.p_name = !tempData.p_name
                                                                setColvis(tempData)
                                                            }}
                                                        /> <span>Publisher Name</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label htmlFor="four">
                                                        <input className="form-check-input" type="checkbox" id="four"
                                                            checked={colvis.createdAt}
                                                            onChange={() => {
                                                                let tempData = { ...colvis }
                                                                tempData.createdAt = !tempData.createdAt
                                                                setColvis(tempData)
                                                            }}
                                                        /> <span>Created At</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label htmlFor="five">
                                                        <input className="form-check-input" type="checkbox" id="five"
                                                            checked={colvis.impressions}
                                                            onChange={() => {
                                                                let tempData = { ...colvis }
                                                                tempData.impressions = !tempData.impressions
                                                                setColvis(tempData)
                                                            }}
                                                        /> <span>Gross Ad Count</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label htmlFor="six">
                                                        <input className="form-check-input" type="checkbox" id="six"
                                                            checked={colvis.givtImpressions}
                                                            onChange={() => {
                                                                let tempData = { ...colvis }
                                                                tempData.givtImpressions = !tempData.givtImpressions
                                                                setColvis(tempData)
                                                            }}
                                                        /> <span>GIVT Ad Count</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label htmlFor="seven">
                                                        <input className="form-check-input" type="checkbox" id="seven"
                                                            checked={colvis.sivtImpressions}
                                                            onChange={() => {
                                                                let tempData = { ...colvis }
                                                                tempData.sivtImpressions = !tempData.sivtImpressions
                                                                setColvis(tempData)
                                                            }}
                                                        /> <span>SIVT Ad Count</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label htmlFor="eight">
                                                        <input className="form-check-input" type="checkbox" id="eight"
                                                            checked={colvis.givtSivtImp}
                                                            onChange={() => {
                                                                let tempData = { ...colvis }
                                                                tempData.givtSivtImp = !tempData.givtSivtImp
                                                                setColvis(tempData)
                                                            }}
                                                        /> <span>IVT</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label htmlFor="nine">
                                                        <input className="form-check-input" type="checkbox" id="nine"
                                                            checked={colvis.viewability}
                                                            onChange={() => {
                                                                let tempData = { ...colvis }
                                                                tempData.viewability = !tempData.viewability
                                                                setColvis(tempData)
                                                            }}
                                                        /> <span>Net Viewability</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label htmlFor="ten">
                                                        <input className="form-check-input" type="checkbox" id="ten"
                                                            checked={colvis.discrep}
                                                            onChange={() => {
                                                                let tempData = { ...colvis }
                                                                tempData.discrep = !tempData.discrep
                                                                setColvis(tempData)
                                                            }}
                                                        /> <span>Discrepancies</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label htmlFor="eleven">
                                                        <input className="form-check-input" type="checkbox" id="eleven"
                                                            checked={colvis.pix_updatedAt}
                                                            onChange={() => {
                                                                let tempData = { ...colvis }
                                                                tempData.pix_updatedAt = !tempData.pix_updatedAt
                                                                setColvis(tempData)
                                                            }}
                                                        /> <span>Updated At</span>
                                                    </label>
                                                </li>


                                            </ul>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>

                        </div>
                    }

                </div>
                <div className="table_content--box table_empty_screen_d2">
                    {loading && !initialLoad &&
                        <div className="table_new_loader_d2">
                            <img src={FullLoader} className="img-fluid" alt="" />
                        </div>
                    }

                    {initialLoad ?
                        <TableLoader />

                        :
                        <Table
                            columns={columnsAll}
                            pageSize={100}
                            dataSource={data}
                            onChange={handleTableChange}
                            pagination={false}
                            rowKey={(record) => record.id}
                            locale={locale}
                            showSorterTooltip={false}
                            // components={components}
                            // loading={loading}
                            // indicator={loading ? loadingIndicator : null}
                            // loadingIndicator={<img src={FullLoader} alt="" />}
                            scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 27rem' }}
                        // scroll={{ x: 1500, y: 'calc(100vh - 27rem' }} 
                        />


                    }

                    {data.length > 0 &&
                        <Row className="custom_pagination--container">
                            <Col span={6}>
                                <div className="form_content_block--group mb_0">
                                    <Select
                                        className='form_select basic sm no_search'
                                        value={page.pageSize}
                                        onChange={handlePageSizeChange}
                                        style={{ width: 80 }}
                                        showSearch={false}
                                        options={[
                                            { value: 10, label: 10 },
                                            { value: 20, label: 20 },
                                            { value: 50, label: 50 },
                                            { value: 100, label: 100 },
                                        ]} />
                                    <label className='custom_pagination--label'>
                                        items per page
                                    </label>
                                </div>
                            </Col>
                            <Col span={6}>
                                <span className="custom_pagination--total-text">
                                    {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                </span>
                            </Col>
                            <Col span={6}>
                                <Pagination
                                    current={page.current}  // Pass individual props instead of spreading them
                                    pageSize={page.pageSize}
                                    total={page.total}
                                    onChange={handlePageChange}
                                    showSizeChanger={false}
                                    itemRender={itemRender}
                                    className="custom_pagination" />
                            </Col>
                        </Row>
                    }
                </div>
            </div>

            {pageView === "create" &&
                <ZoneCreate
                    handlePageViewChange={handlePageView}
                />
            }

            {pageView === "import" &&
                <ZoneImport
                    handlePageViewChange={handlePageView}
                />
            }

            {pageView === "view" &&
                <ZoneViewEdit
                    handlePageViewChange={handlePageViewEdit}
                    zoneCategory={zoneCategory}
                    id={zoneViewId}
                    zoneViewName={zoneViewName}
                />
            }


            <Modal
                centered
                className='custom_modal'
                title={<div className='custom_modal--header --tabs sfdafdsfas'><h3 className='heading'><img src={zoneInfoIcon} alt='USP' /> Zone info</h3>
                    <div className="tab_content--buttons">
                        <>
                            {formTypeList === "Open RTB" ?
                                <>
                                    {items_openrtb.map((item) => (
                                        <button
                                            key={item.key}
                                            onClick={() => onTabChange(item.key)}
                                            className={activeKey === item.key ? 'btn active' : 'btn'}
                                        >
                                            {item.tab}
                                        </button>
                                    ))}
                                </>
                                :
                                formTypeList === "Prebid" ?
                                    <>
                                        {items_prebid.map((item) => (
                                            <button
                                                key={item.key}
                                                onClick={() => onTabChange(item.key)}
                                                className={activeKey === item.key ? 'btn active' : 'btn'}
                                            >
                                                {item.tab}
                                            </button>
                                        ))}
                                    </>
                                    :
                                    formTypeList === "Vast Zone" ?
                                        <>
                                            {items_vastzone.map((item) => (
                                                <button
                                                    key={item.key}
                                                    onClick={() => onTabChange(item.key)}
                                                    className={activeKey === item.key ? 'btn active' : 'btn'}
                                                >
                                                    {item.tab}
                                                </button>
                                            ))}

                                        </>
                                        :
                                        formTypeList === "vast_aniview" ?
                                            <>
                                                {items_vast_aniview.map((item) => (
                                                    <button
                                                        key={item.key}
                                                        onClick={() => onTabChange(item.key)}
                                                        className={activeKey === item.key ? 'btn active' : 'btn'}
                                                    >
                                                        {item.tab}
                                                    </button>
                                                ))}

                                            </>
                                            :
                                            (formTypeList === "Player Tag" || formTypeList === "tag_outstream") ?
                                                <>
                                                    {items_playertag.map((item) => (
                                                        <button
                                                            key={item.key}
                                                            onClick={() => onTabChange(item.key)}
                                                            className={activeKey === item.key ? 'btn active' : 'btn'}
                                                        >
                                                            {item.tab}
                                                        </button>
                                                    ))}

                                                </>
                                                :

                                                formTypeList === "GAM Tag" ?
                                                    <>
                                                        {items_gamtag.map((item) => (
                                                            <button
                                                                key={item.key}
                                                                onClick={() => onTabChange(item.key)}
                                                                className={activeKey === item.key ? 'btn active' : 'btn'}
                                                            >
                                                                {item.tab}
                                                            </button>
                                                        ))}

                                                    </>
                                                    :
                                                    <></>
                            }

                        </>
                    </div>
                </div>}
                visible={isModalVisible}
                onOk={() => { resetModalStateZoneInfo() }}
                onCancel={() => { resetModalStateZoneInfo() }}
                // closable={false} 
                // This removes the default close button
                width={770}
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_end">
                        <button key="submit" className='btn btn_primary w_fit_content' onClick={() => { resetModalStateZoneInfo() }}>
                            Ok
                        </button>
                    </div>
                ]}
            >
                <div className="custom_modal--body">
                    <div className="tab_content--body">
                        <>
                            {formTypeList === "Open RTB" ?
                                <>
                                    {items_openrtb.map((item) => (
                                        <div
                                            key={item.key}
                                            style={{ display: activeKey === item.key ? 'block' : 'none' }}
                                        >
                                            {item.content}
                                        </div>
                                    ))}
                                </>
                                :
                                formTypeList === "Prebid" ?
                                    <>
                                        {items_prebid.map((item) => (
                                            <div
                                                key={item.key}
                                                style={{ display: activeKey === item.key ? 'block' : 'none' }}
                                            >
                                                {item.content}
                                            </div>
                                        ))}
                                    </>
                                    :
                                    formTypeList === "Vast Zone" ?
                                        <>
                                            {items_vastzone.map((item) => (
                                                <div
                                                    key={item.key}
                                                    style={{ display: activeKey === item.key ? 'block' : 'none' }}
                                                >
                                                    {item.content}
                                                </div>
                                            ))}
                                        </>
                                        :
                                        formTypeList === "vast_aniview" ?
                                            <>
                                                {items_vast_aniview.map((item) => (
                                                    <div
                                                        key={item.key}
                                                        style={{ display: activeKey === item.key ? 'block' : 'none' }}
                                                    >
                                                        {item.content}
                                                    </div>
                                                ))}
                                            </>
                                            :
                                            (formTypeList === "Player Tag" || formTypeList === "tag_outstream") ?
                                                <>
                                                    {items_playertag.map((item) => (
                                                        <div
                                                            key={item.key}
                                                            style={{ display: activeKey === item.key ? 'block' : 'none' }}
                                                        >
                                                            {item.content}
                                                        </div>
                                                    ))}
                                                </>
                                                :

                                                formTypeList === "GAM Tag" ?
                                                    <>
                                                        {items_gamtag.map((item) => (
                                                            <div
                                                                key={item.key}
                                                                style={{ display: activeKey === item.key ? 'block' : 'none' }}
                                                            >
                                                                {item.content}
                                                            </div>
                                                        ))}
                                                    </>
                                                    :
                                                    <></>

                            }

                        </>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ZoneListing;
